import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import TableItemActions from "./TableItemActions";

export default function Table({ collection, editData }) {
  const columns = [
    {
      name: "Date",
      selector: "attributes.format_created_at",
      sortable: true,
      sortFunction: (a, b) =>
        a.attributes.created_at_int - b.attributes.created_at_int,
      cell: (row) => <div>{row.attributes.format_created_at}</div>,
    },
    {
      name: "Enterprise",
      selector: "attributes.enterprise",
      sortable: true,
    },
    {
      name: "Team",
      selector: "attributes.team",
      sortable: true,
    },
    {
      name: "Manager",
      selector: "attributes.manager",
      sortable: true,
    },
    {
      name: "Upload Type",
      selector: "attributes.import_type",
      sortable: true,
    },
    {
      name: "Status",
      selector: "attributes.status",
      sortable: true,
    },
    {
      name: "File Name",
      selector: "attributes.file_name",
      sortable: true,
      cell: (row) => <div>{row.attributes.file_name}</div>,
    },
    {
      name: "Records Processed",
      selector: "attributes.count_success",
      sortable: false,
      cell: (row) => (
        <div>
          <div className="red">{row.attributes.validation_errors}</div>
          {(row.attributes.status == "processed" ||
            row.attributes.status == "processed with errors") && (
            <>
              <div className="green mt20">
                Successfully: {row.attributes.count_success}
              </div>
              <div className="red mt10">
                With errors: {row.attributes.count_error}
              </div>
            </>
          )}
        </div>
      ),
    },
    {
      name: "Actions",
      width: "200px",
      cell: (row) => <TableItemActions row={row} editData={editData} />,
      sortable: false,
    },
  ];

  return (
    <>
      <DataTable
        title=""
        columns={columns}
        data={collection}
        noDataComponent="No any records"
        persistTableHead={true}
        pagination
        paginationComponentOptions={{
          selectAllRowsItem: true,
          selectAllRowsItemText: "All",
        }}
      />
    </>
  );
}
